import React, { Fragment, useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';


const optionsAcronym = [
    { value: 'SIN ESTUDIO CLINICO', label: 'SIN ESTUDIO CLINICO' },
    { value: 'APD334-202', label: 'APD334-202' },
    { value: 'APD334-302', label: 'APD334-302' },
    { value: 'APD334-303', label: 'APD334-303' },
    { value: 'APD334-301', label: 'APD334-301' },
    { value: 'PA', label: 'PA' },
    { value: 'HORIZON', label: 'HORIZON' },
    { value: 'PARADISE-MI', label: 'PARADISE-MI' },
    { value: 'PARALLAX', label: 'PARALLAX' },
    { value: 'TQJ230', label: 'TQJ230' },
    { value: 'RESOLUTE', label: 'RESOLUTE' },
    { value: 'PONENTE', label: 'PONENTE' },
    { value: 'DISCOVER', label: 'DISCOVER' },
]

const PatientEnrollment = ({ handlerCandidate, candidate, dataClinicalStudio, participate, handlerParticipate }) => {

    useEffect(()=>{
        validateDataClinicalStudio();
    },[]);

    const validateDataClinicalStudio = () => 
    {
        if(dataClinicalStudio != null && dataClinicalStudio != undefined)
        {
            setAcronym(dataClinicalStudio.estudio.acronimo);
        }
    }

    const [acronym, setAcronym] = useState(null);
    const [wantParticipate, setWantParticipate] = useState(null);

    return (
        <Fragment>
                <Col md={3}>
                    <TextField
                        label="Candidato de Estudio Clinico?"
                        value={candidate}
                        onChange={(event) => {
                            handlerCandidate(event.target.value);
                        }}
                        select
                        style={{ minWidth: '100%', maxWidth: '100%' }}
                        className="medical-material-form__field"
                        InputLabelProps={{
                            style: { color: '#646777' }
                        }}
                    >
                        <MenuItem key={0} value={true}>
                            SI
                        </MenuItem>
                        <MenuItem key={0} value={false}>
                            NO
                        </MenuItem>
                    </TextField>
                </Col>

                {
                    candidate == true ? <>
                        <Col md={3}>
                            
                            {
                                /*
                                <TextField
                                label="Acronimo del Estudio Clinico"
                                value={acronym}
                                onChange={(event) => {
                                    setAcronym(event.target.value)
                                }}
                                select
                                style={{ minWidth: '100%', maxWidth: '100%' }}
                                className="medical-material-form__field"
                                InputLabelProps={{
                                    style: { color: '#646777' }
                                }}
                            >
                                {optionsAcronym.map((item, index) => {
                                    return <MenuItem key={index} value={item.value}>
                                        {item.label}
                                    </MenuItem>
                                })}
                            </TextField>
                                
                                */
                            }
                            
                            <TextField
                                label="Acronimo del Estudio Clinico"
                                value={acronym}
                                disabled={true}
                                onChange={(event) => {
                                    setAcronym(event.target.value)
                                }}
                                style={{ minWidth: '100%', maxWidth: '100%' }}
                                className="medical-material-form__field"
                                InputLabelProps={{
                                    style: { color: '#646777' }
                                }}
                            />

                        </Col>
                        <Col md={3}>
                            <TextField
                                label="Participación en el Estudio Clinico"
                                value={participate}
                                onChange={(event) => {
                                    handlerParticipate(event.target.value)
                                }}
                                select
                                style={{ minWidth: '100%', maxWidth: '100%' }}
                                className="medical-material-form__field"
                                InputLabelProps={{
                                    style: { color: '#646777' }
                                }}
                            >
                                <MenuItem key={0} value={true}>
                                    SI
                                </MenuItem>
                                <MenuItem key={0} value={false}>
                                    NO
                                </MenuItem>
                            </TextField>
                        </Col>
                    </> : null
                }
        </Fragment>
    );
}

export default PatientEnrollment;








